import { render, staticRenderFns } from "./ntripUser.vue?vue&type=template&id=66be32f8&scoped=true"
import script from "./ntripUser.vue?vue&type=script&lang=js"
export * from "./ntripUser.vue?vue&type=script&lang=js"
import style0 from "./ntripUser.vue?vue&type=style&index=0&id=66be32f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66be32f8",
  null
  
)

export default component.exports